// extracted by mini-css-extract-plugin
export default {"p_tye":"_700f7b731c","slcted":"f85f2f693d","slc_color":"b301832df0","item_p":"_1cf4cd30d1","r0":"_8715bc2e94"};